import {SourcingVehicleListItemResponseBody} from '../types';

export const filterOutDuplicates = (
  currentCache: SourcingVehicleListItemResponseBody[],
  newData: SourcingVehicleListItemResponseBody[]
) => {
  const existingAdIds = new Set(currentCache.map((vehicle) => vehicle.sourcingVehicle.adId));
  return newData.filter((vehicle) => !existingAdIds.has(vehicle.sourcingVehicle.adId));
};
